import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { isEmpty } from "lodash";
import ZH_JSON from "locales/zh.js"
import ZHCN_JSON from "locales/zh_cn"
import EN_JSON from "locales/en.js"
import {
    EN,
    FALLBACK_LNG,
    LNG,
    ZH,
    ZH_CN
} from "config/const/locale";
import { STORAGE_LNG } from "config/const/global";
import { zhCN } from "@mui/x-date-pickers/locales";


if (isEmpty(localStorage.getItem(STORAGE_LNG))) localStorage.setItem(STORAGE_LNG, LNG)

/**
 * i18n global config
 * for ref: https://react.i18next.com/guides/quick-start
 */
i18n
    .use(initReactI18next)
    .init({
        resources: {
            [ZH]: ZH_JSON,
            [ZH_CN]: ZHCN_JSON,
            [EN]: EN_JSON
        },
        lng: localStorage.getItem(STORAGE_LNG),
        fallbackLng: FALLBACK_LNG,

        interpolation: {
            escapeValue: false
        }
    })


export default i18n